var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-goal",on:{"click":_vm.onClick}},[_c('Mana',{attrs:{"value":_vm.progress,"subtitle":_vm.subtitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }